'use strict';

/* jshint -W098 */
define('app/templates/_helpers/subview',['Handlebars'], function (Handlebars) {
  return Handlebars.registerHelper('subview', function subview(context, options) {
    /* jshint +W098 */
    if (context.type) {
      return '<div data-name="' + context.name + '" data-subview="' + context.type + '_view" data-subview-index="' + context.index + '" />';
    } else {
      return context;
    }
  });
});
